import { render, staticRenderFns } from "./ManagerProfile.vue?vue&type=template&id=4b93933e&scoped=true"
import script from "./ManagerProfile.vue?vue&type=script&lang=js"
export * from "./ManagerProfile.vue?vue&type=script&lang=js"
import style0 from "./ManagerProfile.vue?vue&type=style&index=0&id=4b93933e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93933e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
